import OrganizationType from './OrganizationType';
export default OrganizationType;
